import { defineStore } from 'pinia';
import PublicService from '@/services/public.service';
import moment from 'moment';
import { useMainStore } from './mainStore';
import { useCoursesStore } from './coursesStore';
import { usePacksCoursesStore } from './packsCoursesStore';
import { useOptionsStore } from './optionsStore';
import { useActivitesStore } from './activitesStore';
import { useArticlesBoutiqueStore } from './articlesBoutiqueStore';
import { useDonationStore } from './donationStore';
import { usePlanEntrainementStore } from './planEntrainementStore';

export const useModuleStore = defineStore('module', {
    state: () => ({
        id: 0,
        nom: '',
        base: '',
        id_evenement: 0,
        date_debut_inscription: moment().format("YYYY-MM-DD"),
        heure_debut_inscription: moment().format("HH:mm"),
        date_fin_inscription: moment().add(1, "d").format("YYYY-MM-DD"),
        heure_fin_inscription: moment().format("HH:mm"),
        status: "",
        url_flyer: "",
        url_reglement: "",
        url_background: "",
        metadatas: [],
        evenement: null,
        nb_inscrits: 0,
        url_resultats: "",
        courses: useCoursesStore(),
        packs_courses: usePacksCoursesStore(),
        options: useOptionsStore(),
        activites: useActivitesStore(),
        articles_boutique: useArticlesBoutiqueStore(),
        donation: useDonationStore(),
        plan_entrainement: usePlanEntrainementStore()

    }),

    actions: {
        async fetchData(override_cache_age = null) {
            let res = await PublicService.fullLoadModule(this.base, override_cache_age);
            if (res) {
                this.set(res.module);
                this.courses.id_module = this.id;
                this.courses.set(res.courses);
                this.packs_courses.id_module = this.id;
                this.packs_courses.set(res.packs);
                this.options.id_module = this.id;
                this.options.set(res.options);
                this.activites.id_module = this.id;
                this.activites.set(res.activites);
                this.articles_boutique.id_module = this.id;
                this.articles_boutique.set(res.articles);
                this.donation.id_module = this.id;
                this.donation.set(res.donation);
                this.plan_entrainement.id_module = this.id;
                this.plan_entrainement.set(res.plan_entrainement);


                /* this.set(res);
                await this.fetchCourses();
                await this.fetchPacksCourses();
                await this.fetchActivites();
                await this.fetchOptions();
                await this.fetchArticlesBoutique(); */
            }
        },


        async fetchCourses() {
            this.courses.id_module = this.id;
            await this.courses.fetchAll();
        },

        async fetchPacksCourses() {
            this.packs_courses.id_module = this.id;
            await this.packs_courses.fetchAll();
        },
        async fetchOptions() {
            this.options.id_module = this.id;
            await this.options.fetchAll();
        },
        async fetchActivites() {
            this.activites.id_module = this.id;
            await this.activites.fetchAll();
        },
        async fetchArticlesBoutique() {
            this.articles_boutique.id_module = this.id;
            await this.articles_boutique.fetchAll();
        },


        set(data) {
            this.id = data.id;
            this.nom = data.nom;
            this.base = data.base;
            this.id_evenement = data.id_evenement;
            this.date_debut_inscription = data.date_debut_inscription;
            this.heure_debut_inscription = data.heure_debut_inscription;
            this.date_fin_inscription = data.date_fin_inscription;
            this.heure_fin_inscription = data.heure_fin_inscription;
            this.status = data.status;
            this.url_resultats = data.url_resultats;
            this.url_flyer = data.url_flyer;
            this.url_reglement = data.url_reglement;
            this.url_background = data.url_background;
            this.metadatas = data.metadatas;
            this.evenement = data.evenement;
            this.nb_inscrits = data.nb_inscrits;
            if (this.url_background != '') {
                document.getElementsByClassName("v-application")[0].style.background = "url('" + this.url_background + "')";
            }
        },

        /**
         * Asynchronously retrieves extra buttons for the home screen.
         * Iterates through the metadata to find keys that include "btn_accueil_" and have non-empty values.
         * Fetches and returns the buttons if such keys are found.
         *
         * @returns {Promise<Array>} A promise that resolves to an array of buttons.
         */
        async get_extra_buttons_accueil() {
            for (const [key, value] of Object.entries(this.metadatas)) {
                if (key.includes("btn_accueil_") && value != '') {
                    let buttons = await this.fetch_buttons();
                    return buttons;

                }
            }
        },

        /**
         * Fetches buttons metadata for the current module.
         * 
         * This asynchronous function retrieves metadata for the current module using the `PublicService.getMetadatas` method.
         * It filters the metadata to include only items whose `nom` property includes 'btn_accueil_'.
         * 
         * @returns {Promise<Array>} A promise that resolves to an array of filtered metadata items.
         */
        async fetch_buttons() {
            let buttons = [];
            let res = await PublicService.getMetadatas("module", this.id);
            if (res) {
                return res.filter((item) => item.nom.includes('btn_accueil_'));
            }
            return buttons;
        },


        has_metadata(k) {
            const match = Object.entries(this.metadatas).find(([key]) => key == k);
            return match ? true : false;
        },
        get_metadata(k) {
            const match = Object.entries(this.metadatas).find(([key]) => key == k);
            return match ? match[1] : null;
        }
        // actions
    },
    getters: {
        isLoaded() {
            return this.id > 0;
        },
        hide_nb_inscrits() {
            if (this.metadatas.masquer_nb_inscrits && this.metadatas.masquer_nb_inscrits == 1) {
                return true;
            }
            if (this.metadatas && this.metadatas.masquer_nb_inscrits_debut == 1 && parseInt(this.nb_inscrits) < 75) {
                return true;
            }
            return false;
        },

        hide_list_inscrits() {
            return this.metadatas?.masquer_liste_inscrits == '1';
        },
        has_limite_participants_globale() {
            if (this.metadatas.limite_participants && this.metadatas.limite_participants == 1) {
                if (this.metadatas.type_limite_participants && this.metadatas.type_limite_participants == "Globale") {
                    if (this.metadatas.nb_limite_globale && this.metadatas.nb_limite_globale > 0) {
                        return true;
                    }
                }
            }
            return false;
        },
        date_time_ouverture_inscriptions() {
            return this.date_debut_inscription + " " + this.heure_debut_inscription;
        },
        disable_webservice_on_launch() {
            const opening = moment(this.date_debut_inscription + " " + this.heure_debut_inscription);
            const six_hours_after_opening = opening.add(2, 'hours');
            const one_hour_before_opening = opening.subtract(1, 'hours');
            const now = moment();
            return now.isBefore(six_hours_after_opening) && now.isAfter(one_hour_before_opening);
        },
        has_url_resultats() {
            return this.url_resultats != "";
        },
        autoriser_transfert_dossard() {
            return this.metadatas?.autoriser_transfert_dossard == "1";
        },
        has_limite_transfert_dossard() {
            return this.metadatas?.limite_transfert_dossard != "";
        },
        autoriser_changement_course() {
            return this.metadatas?.autoriser_changement_course == "1";
        },
        has_limite_changement_course() {
            return this.metadatas?.limite_changement_course != "";
        },
        inscription_plusieurs_courses() {
            return this.metadatas?.inscriptions_plusieurs_courses == "1";
        },
        has_page_race() {
            return this.metadatas?.page_race == '1';
        },
        has_alerte_sms() {
            return this.metadatas?.has_alerte_sms == '1';
        },
        has_plan_entrainement() {
            return this.metadatas?.has_plan_entrainement == '1';
        },
        has_url_site() {
            return this.metadatas?.url_site != "";
        },
        has_url_fb() {
            return this.metadatas?.url_fb != "";
        },
        has_accueil_qr_code() {
            return this.metadatas?.accueil_par_qrcode == '1';
        },
        autorise_acces_billetterie() {
            return this.metadatas?.autorise_acces_billetterie == '1';
        },
        has_exclude_taxe() {
            return this.metadatas?.exclure_taxe == '1';
        },
        has_donation_empreinte_carbone() {
            return this.metadatas?.donation_empreinte_carbone == '1';
        },
        allow_multi_courses() {
            return this.metadatas?.inscriptions_plusieurs_courses == '1';
        },
        disable_inscription_non_sportive() {
            return this.metadatas?.disable_inscription_non_sportive == '1';
        },
        demande_autorisation_parentale() {
            return this.metadatas?.demande_autorisation_parentale == '1';
        },

        texte_autorisation_parentale() {
            return this.metadatas?.texte_autorisation_parentale;
        },
        only_validated_can_register() {
            return this.metadatas?.only_validated_can_register == '1';
        },
        frais_livraison() {
            return this.metadatas?.frais_livraison;
        },
        has_gia() {
            return this.metadatas?.gia == '1';
        },
        has_gia_speciale() {
            return this.metadatas?.has_gia_speciale == '1';
        },
        is_ffrp_event() {
            return this.metadatas?.is_ffrp_event == '1';
        },
        disable_webservice_ffa() {
            return this.metadatas?.disable_webservice_ffa == '1';
        },
        ffa_num_competition() {
            return this.metadatas?.ffa_num_competition;
        },
        is_ffa_module() {
            return this.metadatas?.is_ffa_module == '1';
        },
        has_pps() {
            return this.metadatas?.has_pps == '1';
        },
        replace_cm_by_pps() {
            return this.metadatas?.replace_cm_by_pps == '1';
        },
        donation_empreinte_carbone() {
            return this.metadatas?.donation_empreinte_carbone == '1';
        },
        dernier_delai_gia() {
            return this.metadatas?.dernier_delai_gia;
        },
        envoi_chronopost_boutique() {
            return this.metadatas?.envoi_chronopost_boutique == '1';
        },
        masquer_nb_inscrits_debut() {
            return this.metadatas?.masquer_nb_inscrits_debut == '1';
        },
        masquer_nb_inscrits() {
            return this.metadatas?.masquer_nb_inscrits == '1';
        },
        dossard_offert_groupe() {
            return this.metadatas?.dossard_offert_groupe;
        },
        choix_report_date_max() {
            return this.metadatas?.choix_report_date_max;
        },
        date_fin_documents() {
            return this.metadatas?.date_fin_documents;
        },
        is_longe_cote_ffrp() {
            return this.metadatas?.is_longe_cote_ffrp == '1';
        },
        retirer_cm() {
            return this.metadatas?.retirer_cm == '1';
        },
        has_remove_checkboxes_fin_inscription() {
            return this.metadatas?.remove_checkboxes_fin_inscription == '1';
        },
        hide_sexe_birthdate_fields() {
            return this.metadatas?.hide_sexe_birthdate_fields == '1';
        },
        has_disable_licence() {
            return this.metadatas?.disable_licence == '1';
        },
        has_preinscription() {
            return this.metadatas?.systeme_preinscription == '1';
        },
        preinscription_ended() {
            return this.metadatas?.systeme_preinscription == '0';
        },
        some_races_have_preinscription() {
            return this.courses.list.some(course => course.has_preinscriptions());
        },
        some_vagues_require_justificatif() {
            return this.courses.list.some((course) => {
                if (!course.vagues?.list?.length) {
                    return false;
                }
                return course.vagues.list.some((vague) => vague.requires_justificatif());
            });
        },
        masquer_bouton_inscrire_groupe() {
            return this.metadatas?.masquer_inscrire_groupe_accueil == '1';
        },
        hide_contact_sportips_accueil() {
            return this.metadatas?.hide_contact_sportips_accueil == '1';
        },
        mail_orga_accueil() {
            return this.metadatas?.mail_orga_accueil;
        },
        has_liste_attente_bourse() {
            return this.metadatas?.has_liste_attente_bourse == '1';
        },
        has_lock_options_type_document() {
            return this.metadatas?.lock_options_type_document == '1';
        },

        has_groupe_give_pps_choice() {
            return this.metadatas?.groupe_give_pps_choice == '1';
        },
        has_liste_inscrits_private() {
            return this.metadatas?.liste_inscrits_private == '1';
        },
        is_BICENTENAIRE26_module() {
            return this.base == 'BICENTENAIRE_2026' || this.base == 'BICENTENAIRE_2026_BENEVOLES';
        },
        bourse_dossard_mode() {
            if (this.has_liste_attente_bourse) {
                return 'liste_attente';
            }
            if (this.has_bourse_dossards) {
                return 'direct';
            }
            return 'none';
        },


        accept_pps() {
            const is_module_replace_cm_by_pps = this.metadatas?.replace_cm_by_pps == "1";
            const is_ffa_module = this.metadatas?.is_ffa_module == "1";
            const has_pps = this.metadatas?.has_pps == "1";
            const is_module_ffa_with_pps = is_ffa_module && has_pps;

            // Vérifie si le module n'est pas un module FFA et ne remplace pas les CM par des PPS
            if (!is_ffa_module && !is_module_replace_cm_by_pps) {
                return false;
            }
            // Vérifie si le module n'a pas de PPS et ne remplace pas les CM par des PPS
            if (!has_pps && !is_module_replace_cm_by_pps) {
                return false;
            }
            // Vérifie si la date de fin de l'événement est avant le 1er avril 2024
            if (moment(this.evenement.date_fin).isBefore("2024-04-01")) {
                return false;
            }
            // Retourne vrai si le module est un module FFA avec PPS ou s'il remplace les CM par des PPS
            return is_module_ffa_with_pps || is_module_replace_cm_by_pps;
        },
        is_complet() {
            if (this.metadatas?.limite_participants == "1") {
                if (this.metadatas?.type_limite_participants == "Globale" && this.metadatas?.nb_limite_globale) {
                    if (parseInt(this.nb_inscrits) >= parseInt(this.metadatas?.nb_limite_globale)) {
                        return true;
                    }
                }
            }
            return false;
        },
        is_inscription_open() {
            let now = moment();
            let ouverture_inscription = moment(this.date_debut_inscription + " " + this.heure_debut_inscription);
            let fermeture_inscription = moment(this.date_fin_inscription + " " + this.heure_fin_inscription);

            if (now.isBefore(ouverture_inscription)) {
                return false;

            }
            if (now.isAfter(fermeture_inscription)) {
                return false;
            }
            return true;
        },
        need_gestion_equipe() {
            const need_gestion_equipe = this.courses.has_courses_with_equipe;
            return need_gestion_equipe;
        },
        has_bourse_dossards() {
            return this.metadatas?.has_bourse_dossards == "1";
        },
        bourse_dossards_is_active() {
            if (!this.has_bourse_dossards) {
                return false;
            }
            const limite_transfert_dossard = this.metadatas?.limite_transfert_dossard;
            if (limite_transfert_dossard) {
                const limite_transfert_dossard_date = moment(limite_transfert_dossard);
                limite_transfert_dossard_date.endOf("day");
                if (moment().isAfter(limite_transfert_dossard_date)) {
                    return false;
                }
            }
            return true;
        },
        allCoursesComplets() {

            return this.courses.allCoursesComplets;
        },
        readable_date() {
            const start_date = moment(this.evenement.date_debut);
            const end_date = moment(this.evenement.date_fin);
            if (start_date.isSame(end_date, "day")) {
                return start_date.format("DD MMMM YYYY");
            }

            return "du " + start_date.format("DD MMM") + " au " + end_date.format("DD MMM YYYY");
        },
        readable_status() {
            const mainStore = useMainStore();
            const billetterie_mode = mainStore.billetterie_mode;
            const parcours_billetterie_mode = mainStore.parcours_billetterie_mode;

            if (billetterie_mode || parcours_billetterie_mode) {
                return this.status == "ouverte" ? "Billetterie ouverte" : "Billetterie fermée";
            }
            if (this.has_preinscription) {
                if (this.status === "ouverte") {
                    return "Préinscriptions ouvertes";
                }
                if (this.status === "avant_ouverture") {
                    return "Ouverture des préinscriptions";
                }
                if (this.status === "apres_fermeture") {
                    return "Préinscriptions closes";
                }
            }
            if (this.status == "avant_ouverture") {
                return "Ouverture des inscriptions";
            }
            if (this.status == "apres_fermeture") {
                return "Inscriptions closes";
            }
            if (this.status == "ouverte") {
                return "Ouvert";
            }
            return "";
        },
        readable_status_details() {
            if (this.status == "avant_ouverture") {
                return "le " + moment(this.date_debut_inscription).format("D MMMM") + " à " + this.heure_debut_inscription;
            }
            if (this.status == "apres_fermeture") {
                return "depuis le " + moment(this.date_fin_inscription).format("D MMMM") + " à " + this.heure_fin_inscription;
            }
            if (this.status == "ouverte") {
                return "jusqu'au " + moment(this.date_fin_inscription).format("D MMMM") + " à " + this.heure_fin_inscription;
            }
            return "";
        }

        // getters
    }
});
